import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './styles.module.scss';

const GroupElements = ({
	children,
	gutter,
	className,
	ariaLabel,
	...restProps
}) => {
	const groupElementsCx = cx(styles[`gutter_${gutter}`], className);

	return (
		<div className={groupElementsCx}>
			<div className={styles.inner} aria-label={ariaLabel} {...restProps}>
				{React.Children.map(
					children,
					(block) =>
						block && (
							<div className={styles.block} key={block.key}>
								{block}
							</div>
						)
				)}
			</div>
		</div>
	);
};

GroupElements.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node
	]).isRequired,
	gutter: PropTypes.oneOf(['small']),
	className: PropTypes.string,
	ariaLabel: PropTypes.string
};

export default GroupElements;
